<div class="content">
  <h1>Schnittstellen</h1>
  <p>
    Hier haben Sie die Möglichkeit, Schnittstellen zu anderen Systemen zu konfigurieren.
  </p>
  <div class="mt-l">
    <a href="/datev-integration">
      <img src="/assets/images/datev.svg" alt="Datev link" width="100">
    </a>
  </div>
</div>
